import useTranslation from '../hooks/useTranslation'
import ImageWithBasePath from './ImageWithBasePath'
import MailIcon from '@mui/icons-material/Mail';

export const Footer = () => {
  const translation = useTranslation()
  const data = [
    {
      title: translation.footerFields.emailUs,
      path: 'jobssupport@getlokalapp.com'
    },
    {
      title: translation.footerFields.privacyPolicy,
      path: 'https://getlokalapp.com/?page_id=3'
    },
    {
      title: translation.footerFields.termsAndConditions,
      path: 'https://getlokalapp.com/termsofcontent/'
    }
  ]
  const redirectHandler = (title, path) => {
    if (title === translation.footerFields.emailUs) window.open('mailto:' + path)
    else window.open(path)
  }
  return (
    <div className="w-full px-[25px] pt-[40px] font-noto-sans text-[16px]" id="footer_container">
      <div id="appLogo">
        <ImageWithBasePath src="appLogo" height={20} width={100} alt="getlokalapp logo" />
      </div>
      {data.map((item, index) => (
        <div
          className="mt-[16px] font-noto-sans leading-[24.64px] tracking-[0.5px] text-[#999999]"
          onClick={() => redirectHandler(item.title, item.path)}
          key={index}
          id={item.title}
        >
          {item.title}
        </div>
      ))}
      <div id="support" className='flex gap-[10px] mt-[40px] items-center mb-[10px]'>
        <MailIcon sx={{height:"24px",width:"24px"}}/>
        <a href='mailto:jobssupport@getlokalapp.com' className='text-greyTitleBase900 no-underline'>jobssupport@getlokalapp.com</a>

      </div>
    </div>
  )
}